export default "__VITE_ASSET__CLwTyIvq__"